<template>
    <div>
      <Table border size="large" :columns="tableHeader" :data="chapterData">
        <template slot-scope="{row,index}" slot="setting">
          <a class="jump_color" @click="jumpBorder(index)">切题</a>
          <a class="jump_color" v-if="row.status >= 4 && row.status != 9" @click="paperBookssSheetsBoxes(row.sheetId)">生成</a>
          <a class="jump_color" :href="positionUrl+'/paper/box/' + row.boxedFile" :download="positionUrl+'/paper/box/' + row.boxedFile" target="_blank" v-if="row.status >= 4 && row.status != 9" @click="downloadBorderPdf(index)">校对</a>
        </template>
      </Table>
      <div class="page-jump">
        <Page :total="pageTotal" show-elevator :page-size="size" @on-change="pageJump"/>
      </div>
    </div>
</template>

<script>
  import globalData from "../common/Global.js";
  import { _queryBookChapter,_paperBookssSheetsBoxes} from "../api/api.js";
  import { alertTips } from "../common/common.js";
  export default {
    name: "TeachingChapterList",
    data(){
      return{
        positionUrl: globalData.positionUrl,
        page: 0,
        size: 10,
        id: '',
        digest: '',
        pageTotal: 0,
        tableHeader: [
          {
            title: '课时',
            key: 'lesson'
          },
          {
            title: '页数',
            key: 'page'
          },
          {
            title: '操作',
            key: 'setting',
            slot:"setting"
//            render: (h, params) => {
//              return h('div', [
//                h('Button', {
//                  props: {
//                    type: 'primary',
//                    size: 'small'
//                  },
//                  on: {
//                    click: () => {
//                      this.jumpBorder(params.index)
//                    }
//                  }
//                }, '切题'),
//              ]);
//            }
          }
        ],
        chapterData: []
      }
    },
    created() {
      this.id = this.$route.params.id;
      // this.digest = this.$route.params.digest;
      this.getQueryBookChapter();
    },
    methods: {
//      下载带框的PDF
      downloadBorderPdf(){

      },
//      生成带框的pdf
      paperBookssSheetsBoxes(id){
        const self = this;
        _paperBookssSheetsBoxes(id).then(res => {

        })
      },
      getQueryBookChapter() {
        const self = this;
        _queryBookChapter(self.id, self.page, self.size).then(res => {
          let data = res.data;
          if (data.code === 0) {
            data.data.content.forEach((current,index,arr)=>{
              current.lesson = current.name;
              current.page = current.pageCount
            })
            self.chapterData = data.data.content;
            self.pageTotal = data.data.total;
          } else {
            alertTips("warning", res.message);
          }
        })
        .catch(err => {
          alertTips("error", "网络出小差，请重新生成");
        });
      },
      jumpBorder(index){
        this.$router.push({
          name: 'teachingBorder',
          params: {
            id: this.chapterData[index]['sheetId'],
            src: this.chapterData[index]['srcFile']
          }
        })
      },
      //翻页
      pageJump(n){
        this.page = n-1;
        this.getQueryBookChapter()
      }
    }
  }
</script>

<style scoped>
  .page-jump{
    display: flex;
    justify-content: center;
    padding-top: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/components/TeachingChapterList.vue